var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.numMore > 0)?_c('a',{staticClass:"show-more-item",attrs:{"href":"#","tabindex":"0"},on:{"click":_vm.handleClick}},[_c('div',{staticClass:"item-box"},[_c('div',[_c('span',{staticClass:"num-more"},[_vm._v("+"+_vm._s(_vm.numMore))]),_vm._v(" "),_c('span',{staticClass:"text-uppercase mb-2"},[_vm._v(_vm._s(_vm.typeText))])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }